import SchemaOrg from '@/components/feature/SchemaOrg';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  return (
    <>
      <SchemaOrg type="Organization" data={{
        name: '星辰影院',
        url: 'https://xingchencinema.com',
        description: '星辰影院汇集免费电视剧全集，最新热播剧、国产剧高清在线观看，全程不缓冲流畅播放，追剧首选平台。',
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '关于我们 - 星辰影院',
        description: '了解星辰影院——免费电视剧在线观看平台，品牌故事、用户口碑、联系方式。',
        url: 'https://xingchencinema.com/about',
      }} />
      <SEOHead
        title="关于我们 | 星辰影院 - 免费电视剧在线观看平台"
        description="星辰影院是一个免费电视剧在线观看平台，汇集最新热播剧、国产剧高清不缓冲在线播放。了解我们的品牌故事、发展历程与联系方式。"
        keywords="星辰影院,关于我们,免费电视剧,电视剧全集,在线观看平台"
        canonicalUrl="/about"
      />

      <main className="min-h-screen pt-20 pb-12">
        <div className="max-w-[1000px] mx-auto px-4 md:px-6 lg:px-8">
          <div className="mb-6">
            <Breadcrumb items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]} />
          </div>

          <section className="mb-14 md:mb-20">
            <div className="text-center mb-10">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-50 mb-4">
                关于星辰影院
              </h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
                让每一位观众都能轻松享受高质量的追剧体验
              </p>
            </div>

            <div className="rounded-2xl overflow-hidden aspect-[21/9] mb-10">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20cinema%20interior%20with%20large%20LED%20screens%20showing%20Chinese%20TV%20drama%20content%20dark%20elegant%20atmosphere%20with%20warm%20amber%20accent%20lighting%20cinematic%20and%20sophisticated%20design%20aesthetic&width=1800&height=770&seq=about-hero-001&orientation=landscape"
                alt="星辰影院品牌形象"
                title="星辰影院 - 免费电视剧在线观看平台"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-primary-500/10">
                  <i className="ri-movie-2-line text-xl text-primary-400"></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-100 mb-2">海量资源</h3>
                <p className="text-sm text-foreground-500">汇聚国产、港台、日韩、欧美等全球优质电视剧资源，持续更新中</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-accent-500/10">
                  <i className="ri-speed-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-100 mb-2">极速流畅</h3>
                <p className="text-sm text-foreground-500">采用先进的视频传输技术，高清画质不缓冲，给你流畅的观看体验</p>
              </div>
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60 text-center">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-secondary-500/10">
                  <i className="ri-shield-check-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-100 mb-2">完全免费</h3>
                <p className="text-sm text-foreground-500">无需注册、无需付费、无需会员，让每个人都能免费观看精彩电视剧</p>
              </div>
            </div>
          </section>

          <section className="mb-14 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-8 text-center">
              <a href="#brand-story" className="hover:text-primary-400 transition-colors">品牌故事</a>
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                  星辰影院诞生于对电视剧艺术的热爱。我们深知在快节奏的现代生活中，能够找到一部好剧并安静地享受追剧时光是多么珍贵。
                </p>
                <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                  我们的团队由一群资深的影视爱好者和技术人员组成。我们不仅追求技术上的极致——高清流畅的播放体验，更希望通过精心的内容编排和推荐，帮助每一位用户发现属于自己的好剧。
                </p>
                <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-4">
                  从国产剧到韩剧，从悬疑烧脑到浪漫爱情，从古装权谋到现代都市——无论你有什么样的观剧偏好，星辰影院都能满足你。我们持续追踪全球最新最热的电视剧资源，确保你不会错过任何一部好剧。
                </p>
                <p className="text-sm md:text-base text-foreground-400 leading-relaxed">
                  星辰影院始终坚持"免费、高清、流畅"的核心理念。我们不设付费墙，不强制注册，让每一位观众都能平等地享受优质的电视剧内容。
                </p>
              </div>
              <div className="rounded-2xl overflow-hidden aspect-[4/3]">
                <img
                  src="https://readdy.ai/api/search-image?query=Cozy%20modern%20living%20room%20with%20large%20TV%20screen%20showing%20dramatic%20Chinese%20TV%20drama%20scene%20comfortable%20sofa%20and%20warm%20ambient%20lighting%20cinematic%20home%20entertainment%20aesthetic%20with%20soft%20golden%20and%20deep%20warm%20tones&width=900&height=675&seq=about-story-001&orientation=landscape"
                  alt="星辰影院品牌故事"
                  title="星辰影院 - 品牌故事"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          <section className="mb-14 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-8 text-center">
              <a href="#user-reviews" className="hover:text-primary-400 transition-colors">用户口碑</a>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {[
                {
                  name: '追剧达人小王',
                  rating: 5,
                  text: '星辰影院真的是我用过最流畅的在线追剧平台！高清画质完全不卡顿，而且剧集更新非常及时，强烈推荐给所有追剧爱好者！',
                  date: '2024年7月',
                },
                {
                  name: '影视爱好者小李',
                  rating: 5,
                  text: '分类非常清晰，国产剧、韩剧、美剧一目了然。最赞的是完全免费，不需要注册就能直接看，真的太良心了！',
                  date: '2024年6月',
                },
                {
                  name: '宅家追剧族小张',
                  rating: 5,
                  text: '资源真的很全，很多在其他平台找不到的老剧这里都有。画质清晰，而且没有任何广告弹窗，追剧体验一级棒！',
                  date: '2024年5月',
                },
                {
                  name: '深夜追剧党小陈',
                  rating: 4,
                  text: '推荐算法很精准，每次推荐的剧都是我喜欢的类型。希望以后能增加更多海外剧资源，支持星辰影院越做越好！',
                  date: '2024年4月',
                },
                {
                  name: '剧评博主老刘',
                  rating: 5,
                  text: '作为一个写了十年剧评的人，星辰影院的片库深度和广度让我印象深刻。不仅是新剧，很多经典老剧也都能找到。',
                  date: '2024年3月',
                },
                {
                  name: '上班族追剧小美',
                  rating: 5,
                  text: '下班后的追剧时光全靠星辰影院！手机和电脑都能看，地铁上追剧特别方便。而且从不收费，真心推荐！',
                  date: '2024年2月',
                },
              ].map((review, index) => (
                <div key={index} className="p-5 rounded-xl bg-background-100 border border-background-200/60">
                  <div className="flex items-center gap-1 mb-2">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`w-3 h-3 flex items-center justify-center text-xs ${i < review.rating ? 'ri-star-fill text-primary-400' : 'ri-star-fill text-background-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed mb-3">&ldquo;{review.text}&rdquo;</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs font-medium text-foreground-200">{review.name}</span>
                    <span className="text-xs text-foreground-600">{review.date}</span>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="contact-section" className="mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-8 text-center">
              <a href="#contact-info" className="hover:text-primary-400 transition-colors">联系我们</a>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
                <h3 className="text-lg font-heading font-semibold text-foreground-100 mb-4">联系方式</h3>
                <ul className="space-y-4 text-sm text-foreground-400">
                  <li className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/10">
                      <i className="ri-mail-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <span>contact@xingchencinema.com</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/10">
                      <i className="ri-customer-service-2-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <span>在线客服：7×24小时为您服务</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/10">
                      <i className="ri-map-pin-line text-primary-400 w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <span>中国·北京市朝阳区</span>
                  </li>
                </ul>
              </div>
              <div className="p-6 rounded-xl bg-background-100 border border-background-200/60">
                <h3 className="text-lg font-heading font-semibold text-foreground-100 mb-4">商务合作</h3>
                <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                  我们欢迎各类商务合作，包括但不限于内容授权、广告合作、品牌推广等。如有合作意向，请通过邮件与我们联系。
                </p>
                <p className="text-sm text-foreground-400">
                  合作邮箱：business@xingchencinema.com
                </p>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
}